// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pmticketspg-inline-1 {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  padding: 10px 16px;
  font-size: 12px;
  font-weight: 600;
  color: #2563eb;
  margin-bottom: 12px;
}

.pmticketspg-inline-2 {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.pmticketspg-inline-3 {
  padding: 0;
  overflow-x: auto;
}

.pmticketspg-inline-4 {
  font-family: monospace;
  font-size: 11px;
}

.pmticketspg-inline-5 {
  font-weight: 600;
}

.pmticketspg-inline-6 {
  font-size: 11px;
}

.pmticketspg-inline-7 {
  max-width: 240px;
  font-size: 11px;
  color: #475569;
}

.pmticketspg-inline-8 {
  margin-bottom: 12px;
}

.pmticketspg-inline-9 {
  font-size: 12px;
  background: #f8fafc;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 8px;
}

.pmticketspg-inline-10 {
  font-size: 12px;
  background: #eff6ff;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 8px;
}

.pmticketspg-dyn-1 {
  margin-left: auto;
  font-size: 12px;
  color: var(--pmticketspg-1-color);
}

.pmticketspg-dyn-2 {
  text-align: center;
  padding: 30px;
  color: var(--pmticketspg-2-color);
}

.pmticketspg-dyn-3 {
  text-align: center;
  padding: 30px;
  color: var(--pmticketspg-3-color);
}

.pmticketspg-dyn-4 {
  font-size: 11px;
  font-weight: 600;
  color: var(--pmticketspg-4-color);
}

.pmticketspg-dyn-5 {
  font-size: 11px;
  color: var(--pmticketspg-5-color);
}

.pmticketspg-dyn-6 {
  font-size: 11px;
  color: var(--pmticketspg-6-color);
  margin-bottom: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/PM/PMTicketsPg.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,kBAAkB;AACpB","sourcesContent":[".pmticketspg-inline-1 {\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 10px;\n  padding: 10px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #2563eb;\n  margin-bottom: 12px;\n}\n\n.pmticketspg-inline-2 {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.pmticketspg-inline-3 {\n  padding: 0;\n  overflow-x: auto;\n}\n\n.pmticketspg-inline-4 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.pmticketspg-inline-5 {\n  font-weight: 600;\n}\n\n.pmticketspg-inline-6 {\n  font-size: 11px;\n}\n\n.pmticketspg-inline-7 {\n  max-width: 240px;\n  font-size: 11px;\n  color: #475569;\n}\n\n.pmticketspg-inline-8 {\n  margin-bottom: 12px;\n}\n\n.pmticketspg-inline-9 {\n  font-size: 12px;\n  background: #f8fafc;\n  padding: 10px;\n  border-radius: 8px;\n  margin-bottom: 8px;\n}\n\n.pmticketspg-inline-10 {\n  font-size: 12px;\n  background: #eff6ff;\n  padding: 10px;\n  border-radius: 8px;\n  margin-bottom: 8px;\n}\n\n.pmticketspg-dyn-1 {\n  margin-left: auto;\n  font-size: 12px;\n  color: var(--pmticketspg-1-color);\n}\n\n.pmticketspg-dyn-2 {\n  text-align: center;\n  padding: 30px;\n  color: var(--pmticketspg-2-color);\n}\n\n.pmticketspg-dyn-3 {\n  text-align: center;\n  padding: 30px;\n  color: var(--pmticketspg-3-color);\n}\n\n.pmticketspg-dyn-4 {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--pmticketspg-4-color);\n}\n\n.pmticketspg-dyn-5 {\n  font-size: 11px;\n  color: var(--pmticketspg-5-color);\n}\n\n.pmticketspg-dyn-6 {\n  font-size: 11px;\n  color: var(--pmticketspg-6-color);\n  margin-bottom: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
